<template>
  <div class="content-wrapper">
    <section class="content-header">
      <div class="container-fluid">
        <div class="row mb-2">
          <div class="col-sm-12">
            <h1>
              Open VPN Client
              <router-link
                :to="{ name: 'OpenVPNClientAdd' }"
                class="btn ml-auto"
                v-if="actionCreate && hasCreatedServer"
              >
                <i class="icon-plus"></i> New
              </router-link>
            </h1>
          </div>
          <div class="col-sm-6">
            <ol class="breadcrumb float-sm-right">
              <li class="breadcrumb-item">
                <router-link :to="{ name: 'Home' }">Home</router-link>
              </li>
              <li class="breadcrumb-item active">Open VPN Client</li>
            </ol>
          </div>
        </div>
      </div>
      <!-- /.container-fluid -->
    </section>

    <section class="content" v-if="has_permission === true">
      <div class="container-fluid">
        <div class="card">
          <div
            class="card-header py-3"
            v-if="!_.isEmpty(list.data) && is_loading == false"
          >
            <div class="btn-toolbar pull-right">
              <el-dropdown
                split-button
                :trigger="'click'"
                @command="handleSelectedRows"
                type="primary"
                v-if="this.selected_row.length"
                class="mr-1"
              >
                {{ this.selected_row.length }}
                {{ "item" | pluralize(this.selected_row.length) }} selected
                <el-dropdown-menu slot="dropdown">
                  <el-dropdown-item command="enable">ENABLE</el-dropdown-item>
                  <el-dropdown-item command="disable">DISABLE</el-dropdown-item>
                  <el-dropdown-item command="delete">DELETE</el-dropdown-item>
                </el-dropdown-menu>
              </el-dropdown>
              <button
                class="btn btn-info"
                type="button"
                @click="showFilter = !showFilter"
              >
                <i class="fa fa-filter"></i>
                <span class="d-none d-sm-inline-flex">Filter</span>
              </button>
            </div>
            <!-- <div class="card-tools" v-if="1 == 0">
              <button class="btn btn-outline" @click="exportFile()">
                <i class="icon-download"></i>
                <span class="d-none d-sm-inline-flex">Export</span>
              </button>
            </div> -->
          </div>
          <div class="overlay" v-if="is_loading">
            <img src="/assets/images/loader.svg" alt="" />
          </div>
          <form @submit.prevent="getFilterData()" method="GET" novalidate>
            <div class="card-body" v-if="showFilter">
              <div class="form-row">
                <div class="col-md-6">
                  <!-- Audra Name -->
                  <div v-if="organizationId == 1" class="form-group form-row">
                    <label class="col-md-3 col-form-label" for="audraname">Audra</label>
                    <div class="col-md-9">
                      <div class="input-group">
                        <multiselect
                          v-model="filter.accountId"
                          :options="Object.keys(pre.audraName)"
                          :custom-label="(opt) => pre.audraName[opt]"
                          placeholder="Select Audra"
                          :searchable="true"
                          :multiple="false"
                          id="accountId"
                          v-bind:class="{
                            'has-error': errors.has('accountId'),
                          }"
                          name="accountId"
                        >
                        </multiselect>
                      </div>
                    </div>
                  </div>

                  <!-- Name -->
                  <div class="form-group form-row">
                    <label class="col-md-3 col-form-label" for="client_name">Name</label>
                    <div class="col-md-9">
                      <div class="input-group">
                        <div class="input-group-prepend">
                          <span class="input-group-text">
                            <i class="fas fa-pencil-alt"></i>
                          </span>
                        </div>
                        <input
                          autocomplete="off"
                          type="text"
                          id="client_name"
                          name="client_name"
                          v-model="filter.client_name"
                          :class="{
                            'has-error': errors.has('name'),
                          }"
                          class="form-control"
                          placeholder="Name"
                        />
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <div class="row">
                <div class="col-md-6">
                  <div class="row justify-content-end">
                    <div class="col-md-9">
                      <button type="submit" class="btn mr-3">
                        <i class="icon-search"></i> Search
                      </button>
                      <button type="reset" class="btn btn-outline" @click="resetFilter()">
                        <i class="icon-refresh"></i> Reset
                      </button>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </form>

          <div class="card-body">
            <div v-if="!_.isEmpty(list.data) && is_loading == false">
              <h6>Total Item: {{ list.total }}</h6>
              <div class="table-responsive-md">
                <table class="table">
                  <thead>
                    <tr>
                      <th style="width: 24px">
                        <label class="checkbox">
                          <input
                            type="checkbox"
                            v-model="is_selected_all"
                            @click="selectedRowAll()" />
                          <span class="checkmark"></span
                        ></label>
                      </th>
                      <th v-if="organizationId == 1">Audra</th>
                      <th>Name</th>
                      <th v-if="vpnType == 0">Password</th>
                      <th>Status</th>
                      <th class="text-right">Action</th>
                    </tr>
                  </thead>
                  <tbody class="list">
                    <tr v-for="(val, index) in list.data">
                      <td>
                        <label class="checkbox">
                          <input
                            type="checkbox"
                            v-model="selected_row"
                            :value="{ id: val.id, accountId: val.accountId }" />
                          <span class="checkmark"></span
                        ></label>
                      </td>
                      <td v-if="organizationId == 1">
                        {{ val.device_name }}
                      </td>
                      <td>{{ val.client_name.replace("_", " ") }}</td>
                      <!-- <td v-if="vpnType == 0">{{ val.password }}</td> -->
                      <td v-if="vpnType == 0">
                        <div class="d-flex align-items-center">
                          <span v-if="showPasswordMap[val.id]">
                            {{ val.decrypted_password || val.password }}
                          </span>
                          <span v-else> {{ "**********" }} </span>
                          <button
                            class="btn btn-sm ml-2"
                            :disabled="decryptingPassword[val.id]"
                            @click="togglePassword(val)"
                          >
                            <i
                              :class="[
                                decryptingPassword[val.id]
                                  ? 'fa fa-spinner fa-spin'
                                  : showPasswordMap[val.id]
                                  ? 'icon-eye-off'
                                  : 'icon-eye',
                              ]"
                            ></i>
                          </button>
                        </div>
                      </td>

                      <td>{{ val.vpn_status }}</td>
                      <td class="text-right">
                        <!-- <router-link
                          v-if="actionView == false"
                          :to="{
                            name: 'OpenVPNClientShow',
                            params: { id: val.id },
                          }"
                          class="btn btn-view"
                        >
                          <i class="icon-eye"></i>
                        </router-link> -->

                        <router-link
                          v-if="vpnType == 0"
                          :to="{
                            name: 'OpenVPNClientEdit',
                            params: { id: val.id },
                          }"
                          class="btn btn-edit"
                        >
                          <i class="icon-edit"></i>
                        </router-link>

                        <a
                          v-if="actionDownload == true && vpnType == 1"
                          class="btn btn-edit"
                          href="javascript:void(0)"
                          @click="
                            downloadClient(val.id, val.accountId, val.client_name, index)
                          "
                        >
                          <i class="icon-download"></i
                        ></a>

                        <a
                          v-if="actionDelete == true || checkDeletePermission(val)"
                          class="btn btn-trash"
                          href="javascript:void(0)"
                          @click="deleteObject(val.id, val.accountId, index)"
                          ><i class="icon-trash"></i
                        ></a>
                      </td>
                    </tr>
                  </tbody>
                </table>
              </div>
            </div>
            <div class="p-4" v-if="_.isEmpty(list.data) && is_loading == false">
              <div class="no-data">
                <img src="/assets/images/no-data.svg" alt="" />
                <h3>No data found!</h3>
              </div>
            </div>
          </div>

          <div :class="{ 'card-footer': list.total > list.per_page }">
            <vue-pagination
              :pagination="list"
              v-if="list.total > list.per_page"
              @paginate="reload()"
            ></vue-pagination>
          </div>
        </div>
      </div>
    </section>

    <section class="content" v-if="has_permission === false">
      <div class="alert alert-danger alert-dismissible">
        <h5><i class="icon fas fa-ban"></i> Permission denied!</h5>
      </div>
    </section>
  </div>
</template>

<script>
import VuePagination from "@/components/partials/PaginationComponent";
import SortIcons from "@/components/utils/SortIcons";
import { CommonAPI, PermissionChecker } from "@/services/api";
import LocalStorage from "@/services/localStorage";
import axios from "axios";
import { Notification } from "element-ui";
import DatePicker from "vue2-datepicker";
import "vue2-datepicker/index.css";
import { mapGetters } from "vuex";
// const fileDownload = require("js-file-download");
import { fileDownload } from "@/utils/CommonUtils";

export default {
  name: "OpenVPNClient",
  metaInfo: {
    title: "Open VPN Client | Dotlines",
  },
  components: {
    DatePicker,
    VuePagination,
    SortIcons,
  },
  data: () => ({
    showPasswordMap: {},
    decryptingPassword: {},
    organizationId: LocalStorage.get("organizationId"),
    userEmail: LocalStorage.get("userEmail"),
    vpnType: 1, // 1 for cirtificate based vpn and 0 for user password based vpn.
    list: {
      total: 0,
      per_page: 1,
      from: 1,
      to: 0,
      current_page: 1,
    },
    hasCreatedServer: 0,
    actionCreate: true,
    actionView: true,
    actionEdit: true,
    actionDelete: true,
    actionDownload: true,
    api_url: "",
    showFilter: false,
    filter: {},
    dateRange: "",
    pre: {
      audraName: {},
    },
    is_loading: false,
    empty: false,
    empty_message: "",
    custom_permission_data: [],
    has_permission: true,
    selected_row: [],
    is_selected_all: false,
  }),
  mounted: function () {
    if (this.isMobile()) {
      window.$(document).find(".push-menu-class").trigger("click");
    }
    this.hasServer();
    this.getOpenVpnType();
    this.api_url = "/open_vpn_clients";
    this.initialize();
    this.$root.$on("sort-data", () => {
      this.$root.$emit("show-icon");
      this.reload();
    });
  },
  computed: {
    ...mapGetters(["profile"]),
  },
  methods: {
    async initialize() {
      this.is_loading = true;
      if (_.isEmpty(this.profile)) {
        await CommonAPI.getProfile().then((profile_info) => {
          this.user_detail = profile_info;
        });
      } else {
        this.user_detail = this.profile;
      }

      // await CommonAPI.getCustomPermission(
      //   "/get-custom-permission-infos?path=api/open_vpn_clients"
      // ).then((response) => {
      //   if (response.status == 200) {
      //     this.custom_permission_data = response.data;
      //   }
      // });

      // if (!_.isEmpty(this.custom_permission_data)) {
      //   this.actionCreate = await PermissionChecker.checkCreateButtonPermission(
      //     this.custom_permission_data.action_permission,
      //     this.custom_permission_data["create_id_condition"],
      //     this.user_detail,
      //     this.custom_permission_data.enableAdministratorPermissionByDefault
      //   );
      //   this.actionCreate = true;
      // }

      await this.getList()
        .then((response) => {
          this.list = response.data;
        })
        .catch((error) => {
          this.empty = true;
          if (error.response.status === 403) {
            this.has_permission = false;
          }
        });

      await CommonAPI.getAudraName(LocalStorage.get("accountId"))
        .then((response) => {
          this.pre.audraName = response;
        })
        .catch((error) => {
          console.log(error.response);
        });

      this.is_loading = false;
    },
    async getFilterData() {
      this.is_loading = true;
      await this.getList()
        .then((response) => {
          this.list = response.data;
        })
        .catch((error) => {
          this.empty = true;
          if (error.response.status === 403) {
            this.has_permission = false;
          }
        });
      this.is_loading = false;
    },
    reload: function () {
      this.getList()
        .then((response) => {
          this.list = response.data;
        })
        .catch((error) => {
          this.empty = true;
          if (error.response.status === 403) {
            this.has_permission = false;
          }
        });
    },
    getList: function () {
      return new Promise((resolve, reject) => {
        let params = { page: this.list.current_page };
        params = {
          ...this.filter,
          userAccountId: LocalStorage.get("accountId"),
          ...this.$route.query,
          ...params,
        };
        axios
          .get(this.api_url, {
            params: params,
          })
          .then((response) => {
            resolve(response);
          })
          .catch((error) => {
            reject(error);
            // console.log("error", error.response.data);
          })
          .finally(() => {
            // _this.is_loading = false;
          });
      });
    },
    checkEditPermission: function (data) {
      if (!_.isEmpty(this.custom_permission_data)) {
        return PermissionChecker.checkEditButtonPermission(
          this.custom_permission_data.action_permission,
          this.custom_permission_data["edit_id_condition"],
          this.custom_permission_data["edit_refid_condition"],
          this.custom_permission_data["edit_custom_condition"],
          data,
          this.user_detail,
          this.custom_permission_data.enableAdministratorPermissionByDefault
        );
      } else {
        return false;
      }
    },
    checkDeletePermission: function (data) {
      if (!_.isEmpty(this.custom_permission_data)) {
        return PermissionChecker.checkDeleteButtonPermission(
          this.custom_permission_data.action_permission,
          this.custom_permission_data["delete_id_condition"],
          this.custom_permission_data["delete_refid_condition"],
          this.custom_permission_data["delete_custom_condition"],
          data,
          this.user_detail,
          this.custom_permission_data.enableAdministratorPermissionByDefault
        );
      } else {
        return false;
      }
    },
    async resetFilter() {
      this.list.current_page = 1;
      this.filter = {};
      this.is_loading = true;
      await this.getList()
        .then((response) => {
          this.list = response.data;
        })
        .catch((error) => {
          this.empty = true;

          if (error.response.status === 403) {
            this.has_permission = false;
          }
        });
      this.is_loading = false;
    },
    deleteObject: function (id, accountId, index) {
      const _this = this;
      const delete_api_url = "/open_vpn_clients/" + id;

      _this.$swal
        .fire({
          title: "Are you sure?",
          text: "You won't be able to revert this!",
          icon: "warning",
          showCancelButton: true,
          confirmButtonColor: "#3085d6",
          cancelButtonColor: "#d33",
          confirmButtonText: "Yes, delete it!",
        })
        .then((result) => {
          if (result.isConfirmed) {
            _this.is_loading = true;
            axios
              .delete(delete_api_url, {
                params: {
                  accountId: accountId,
                },
              })
              .then((response) => {
                _this.list.data.splice(index, 1);
                _this.$toaster.success(response.data.message);
                _this.is_loading = false;
              })
              .catch((error) => {
                _this.is_loading = false;
                console.log(error);
                _this.$swal.fire("Failed!", "failed to delete.", "error");
              })
              .finally(() => {
                _this.is_loading = false;
              });
          }
        });
    },

    downloadClient: function (id, accountId, clientName, index) {
      const _this = this;
      const download_api_url =
        "/downloadClient/" + accountId + "_" + clientName + ".ovpn";

      _this.is_loading = true;
      axios
        .get(download_api_url, {
          responseType: "blob",
        })
        .then((response) => {
          fileDownload(response.data, clientName + ".ovpn");
          _this.$toaster.success("Downloaded Successfully");
          _this.is_loading = false;
        })
        .catch((error) => {
          _this.is_loading = false;
          if (error.response.status === 501) {
            error.response.data.text().then((text) => {
              const textErrors = JSON.parse(text);
              _this.$toaster.warning(textErrors.errors.message);
            });
          } else if (error.response.data) {
            _this.$toaster.error(error.response.data.message);
          }
        })
        .finally(() => {
          _this.is_loading = false;
        });
    },
    exportFile: function () {
      this.is_loading = true;
      axios
        .get("/open-vpn-clients-export", {
          params: { userAccountId: LocalStorage.get("accountId") },
          responseType: "blob",
        })
        .then((response) => {
          fileDownload(response.data, "open_vpn_clients.xlsx");
        })
        .catch((error) => {
          console.log("error " + error);
        })
        .finally(() => {
          this.is_loading = false;
          Notification.success({
            title: "Export Completed",
            message: "Export operation completed successfully",
            type: "success",
          });
        });
    },
    selectedRowAll: function () {
      const isSelectedAll = (this.is_selected_all = !this.is_selected_all);
      if (isSelectedAll) {
        var items = [];
        this.list.data.forEach(function (item) {
          items.push({ id: item.id, accountId: item.accountId });
        });
        this.selected_row = items;
      } else {
        this.selected_row = [];
      }
    },
    handleSelectedRows(command) {
      let type = 0;
      let notificationMessage;
      let notificationTitle;
      const _this = this;

      if (command === "delete") {
        notificationMessage = "Data deleted successfully";
        notificationTitle = "Deleted Successfully";
      } else {
        if (command === "enable") {
          type = 1;
        }
        notificationMessage = "Data Updated successfully";
        notificationTitle = "Updated Successfully";
      }

      axios({
        method: "POST",
        url: "/open_vpn_clients-bulk-action",
        data: { ids: this.selected_row, type: type, action: command },
        headers: { "Content-Type": "application/json" },
      })
        .then(function (response) {
          Notification.success({
            title: notificationTitle,
            message: notificationMessage,
            type: "success",
          });
          // this.initialize();
        })
        .catch((errors) => {
          if (errors.response.status === 501) {
            _this.$toaster.error(errors.response.data.errors.message);
          } else if (errors.response.data) {
            _this.$toaster.error(errors.response.data.message);
          }
        })
        .finally(() => {
          this.is_selected_all = false;
          this.selected_row = [];
          this.initialize();
        });
    },
    getOpenVpnType: function () {
      axios
        .get("get-openvpn-type", {
          params: { accountId: LocalStorage.get("accountId") },
        })
        .then((response) => {
          this.vpnType = response.data;
        })
        .catch((error) => {
          console.log("error " + error);
        })
        .finally(() => {});
    },
    hasServer: function () {
      axios
        .get("has-created-server", {
          params: { accountId: LocalStorage.get("accountId") },
        })
        .then((response) => {
          this.hasCreatedServer = response.data;
        })
        .catch((error) => {
          console.log("error " + error);
        })
        .finally(() => {});
    },
    async decryptPassword(id, index) {
      this.$set(this.list.data[index], "decrypting", true);
      axios
        .get("decrypt-openvpn-password", {
          params: {
            accountId: LocalStorage.get("accountId"),
            id: id,
          },
        })
        .then((response) => {
          this.$set(this.list.data[index], "decrypted_password", response.data);
        })
        .catch((error) => {
          console.log("error " + error);
        })
        .finally(() => {
          this.$set(this.list.data[index], "decrypting", false);
        });
    },
    async togglePassword(row) {
      const id = row.id;

      if (this.showPasswordMap[id]) {
        this.$set(this.showPasswordMap, id, false);
        return;
      }

      if (row.decrypted_password) {
        this.$set(this.showPasswordMap, id, true);
        return;
      }

      this.$set(this.decryptingPassword, id, true);
      axios
        .get("decrypt-openvpn-password", {
          params: {
            accountId: LocalStorage.get("accountId"),
            id: row.id,
          },
        })
        .then((response) => {
          this.$set(row, "decrypted_password", response.data);
          this.$set(this.showPasswordMap, id, true);
        })
        .catch((error) => {
          console.log("error " + error);
        })
        .finally(() => {
          this.$set(this.decryptingPassword, id, false);
        });
    },
  },
};
</script>
